import { render, staticRenderFns } from "./TextyFooter.vue?vue&type=template&id=03017172"
import script from "./TextyFooter.vue?vue&type=script&lang=js"
export * from "./TextyFooter.vue?vue&type=script&lang=js"
import style0 from "./TextyFooter.vue?vue&type=style&index=0&id=03017172&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports